interface NoteSlice {
    note: string;
    setNote: (note: string) => void;
    resetNote: () => void;
}

const createNoteSlice = (set: any) => ({
    note: '',
    setNote: (note: string) => set({ note }),
    resetNote: () =>
        set({
            note: '',
        }),
});

export { createNoteSlice };
export type { NoteSlice };
